module.exports = __webpack_public_path__ + "static/img/profile-photo-placeholder.5a57d134.svg";